import React from "react";
import { Provider } from "mobx-react";
import store from "./src/store/";

export const wrapRootElement = ({ element }) => (
  <Provider store={store}>{element}</Provider>
);
